import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
const PersonalBrand = () => (
  <span className="flex items-center gap-3" data-testid="nav-personal-brand">
    <span className="grid h-9 w-9 place-items-center rounded-full bg-orange font-display text-sm font-black tracking-tight text-white">RG</span>
    <span className="text-left font-display text-base font-extrabold leading-none tracking-tight text-white">
      Rui <span className="text-orange">Guedes</span>
      <span className="mt-1 block font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-slate-300">Fundador · Soluções Ideais</span>
    </span>
  </span>
);
import { scrollToId, openCal } from "./smooth";

const LINKS = [
  ["historia", "A História"],
  ["metodo", "O Que Fazemos"],
  ["transformacao", "Transformação"],
  ["caso", "Sucesso"],
  ["investimento", "Investimento"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled || open ? "border-b border-white/10 bg-navy/85 backdrop-blur-xl" : "border-b border-transparent"}`}
    >
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <button onClick={() => go("top")} data-testid="nav-logo-link"><PersonalBrand /></button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`} className="link-underline text-sm font-medium text-slate-200 hover:text-white">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={() => openCal()}
            data-testid="nav-cta-button"
            className="group hidden items-center gap-2 rounded-full bg-orange px-5 py-2.5 text-sm font-bold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-orange-deep sm:flex"
          >
            Agendar Conversa
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
          </button>
          <button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" className="rounded-full border border-white/20 p-2.5 text-white lg:hidden" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="border-t border-white/10 px-5 pb-6 lg:hidden" data-testid="nav-mobile-menu">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-mobile-link-${id}`} className="block w-full border-b border-white/10 py-4 text-left font-display text-xl font-bold text-white">
              {label}
            </button>
          ))}
          <button onClick={() => { setOpen(false); openCal(); }} data-testid="nav-mobile-cta" className="mt-5 w-full rounded-full bg-orange py-3.5 font-bold text-white">
            Agendar Conversa
          </button>
        </div>
      )}
    </header>
  );
};
